<template>
  <div class="title-preview-media" :class="{ 'title-preview-media--playing': playing }">
    <img v-if="image" :src="image" alt="" class="title-preview-media__image" />
    <div v-else class="title-preview-media__fallback" aria-hidden="true">
      <svg width="52" height="52" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="1.3" d="M4 5h16v14H4zM10 9l5 3-5 3z"/></svg>
    </div>
    <MutedTrailerPreview
      v-if="started"
      :key="trailerId"
      :video-id="trailerId"
      :title="title"
      @playing="playing = true"
      @ended="stop"
      @unavailable="stop"
    />
  </div>
  <div v-if="started" class="title-preview-media__caption">
    <span>{{ playing ? 'Muted trailer preview' : 'Starting trailer…' }}</span>
    <button v-if="started" type="button" @click="stop">Stop preview</button>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, watch } from 'vue'
import MutedTrailerPreview from '@/components/MutedTrailerPreview.vue'
import { canAutoPreview } from '@/composables/useTitlePreview'

const props = defineProps({
  image: { type: String, default: '' },
  trailerId: { type: String, default: null },
  title: { type: String, default: '' },
  autoPreview: { type: Boolean, default: false },
  delay: { type: Number, default: 1300 },
})
const started = ref(false)
const playing = ref(false)
let timer
let stopped = false
let motionPreference
function stop() {
  clearTimeout(timer)
  started.value = false
  playing.value = false
  stopped = true
}
function schedule() {
  clearTimeout(timer)
  started.value = false
  playing.value = false
  if (stopped || !props.autoPreview || !props.trailerId || !canAutoPreview()) return
  timer = setTimeout(() => {
    if (props.autoPreview && canAutoPreview()) started.value = true
  }, props.delay)
}
function onVisibility() { if (document.hidden) stop() }
function onBlur() { stop() }
function onMotionChange(event) { if (event.matches) stop() }
watch(() => [props.trailerId, props.autoPreview], () => { stopped = false; schedule() }, { immediate: true })
onMounted(() => {
  document.addEventListener('visibilitychange', onVisibility)
  window.addEventListener('blur', onBlur)
  motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)')
  motionPreference.addEventListener?.('change', onMotionChange)
})
onBeforeUnmount(() => {
  clearTimeout(timer)
  document.removeEventListener('visibilitychange', onVisibility)
  window.removeEventListener('blur', onBlur)
  motionPreference?.removeEventListener?.('change', onMotionChange)
})
</script>
